var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87144 0.813346L8.01684 2.87476C8.17378 3.15772 8.56768 3.42651 8.89158 3.46284L10.8196 3.70404C12.054 3.85581 12.3724 4.72771 11.5323 5.64097L10.101 7.18811C9.86203 7.44739 9.738 7.94201 9.83401 8.28151L10.3355 10.103C10.73 11.5411 9.9798 12.1371 8.66155 11.4308L6.82004 10.4438C6.48465 10.2634 5.95192 10.2897 5.63683 10.4923L3.88381 11.6215C2.62887 12.4287 1.83031 11.8973 2.10567 10.4331L2.45828 8.58012C2.52411 8.23375 2.36628 7.7504 2.10576 7.51261L0.5512 6.08811C-0.361035 5.24891 -0.115654 4.35449 1.09994 4.1009L2.99801 3.70632C3.31834 3.63707 3.68955 3.34484 3.81989 3.04751L4.79233 0.895768C5.31533 -0.26582 6.25305 -0.302332 6.87144 0.813346Z",
    fill: "#D77910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart37);
export default __webpack_public_path__ + "static/media/start-37.34cb3d8d8c348dfacff529994eb35cc5.svg";
export { ForwardRef as ReactComponent };